export const GRAPHQL_VARIABLES = {
  filter: {
    _id: ''
  }
};

export const QUERY = `
 mutation individualRemoveOne ($filter: AutoFilledFilterRemoveOneindividualsInput!) {
   individualRemoveOne (filter: $filter) {
       recordId
   }
 }
 `;
